import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useId } from 'react';
export const Background = /*#__PURE__*/_styled(({
  from,
  to,
  className,
  isTeaser
}) => {
  const idA = useId();
  const idB = useId();
  const idC = useId();
  const idD = useId();
  const idE = useId();
  const idF = useId();
  if (isTeaser) {
    return _jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 300 370",
      className: className,
      children: [_jsxs("g", {
        clipPath: `url(#${idA})`,
        children: [_jsx("path", {
          fill: `url(#${idB})`,
          d: "M0 0h930v400H0z"
        }), _jsx("path", {
          fill: `url(#${idC})`,
          d: "M126.4-10H-430v420h981c-11.2-34.4-67-43.7-80.2-49.7-13.3-6-113-37-113-92.7 0-31.8-3-69-24.4-104-16.7-27.4-92-52.8-126.9-57-38.8-4.2-112.2-21.5-95.5-57 16.7-35.5 17.2-54.5 15.4-59.6Z"
        }), _jsx("path", {
          fill: `url(#${idD})`,
          d: "M-136.2 0H-570v400h870.6c-8.8-27.2-81.6-60-114-69-27.2-7.6-95.2-20.2-114-72.1C59.4 222.2 98.3 102.9-6 81.6-136.2 55.1-131.8 18.4-136.2 0Z"
        })]
      }), _jsxs("defs", {
        children: [_jsxs("linearGradient", {
          id: idB,
          x1: "624.1",
          x2: "294.3",
          y1: "-217",
          y2: "-154.5",
          gradientUnits: "userSpaceOnUse",
          children: [_jsx("stop", {
            stopColor: to
          }), _jsx("stop", {
            offset: "1",
            stopColor: from
          })]
        }), _jsxs("linearGradient", {
          id: idC,
          x1: "228.3",
          x2: "-119.4",
          y1: "-237.9",
          y2: "-171.7",
          gradientUnits: "userSpaceOnUse",
          children: [_jsx("stop", {
            stopColor: to
          }), _jsx("stop", {
            offset: "1",
            stopColor: from
          })]
        }), _jsxs("linearGradient", {
          id: idD,
          x1: "181",
          x2: "-467.8",
          y1: "0",
          y2: "175",
          gradientUnits: "userSpaceOnUse",
          children: [_jsx("stop", {
            stopColor: from
          }), _jsx("stop", {
            offset: "1",
            stopColor: "#001D52"
          })]
        }), _jsx("clipPath", {
          id: idA,
          children: _jsx("path", {
            fill: "#fff",
            d: "M0 0h930v400H0z"
          })
        })]
      })]
    });
  }
  return _jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1248 100",
    className: className,
    children: [_jsxs("g", {
      clipPath: `url(#${idA})`,
      children: [_jsx("path", {
        fill: `url(#${idB})`,
        d: "M0 0h1248v100H0z"
      }), _jsx("path", {
        fill: `url(#${idC})`,
        d: "M394.7-11H0v298h696c-8-24.4-47.5-31-56.9-35.3-9.4-4.2-80.1-26.3-80.1-65.8 0-22.5-2.1-48.8-17.3-73.8-12-19.4-65.3-37.4-90-40.4-27.6-3-79.7-15.2-67.8-40.4C395.7 6.1 396-7.4 394.7-11Z"
      }), _jsx("path", {
        fill: `url(#${idD})`,
        d: "M141.9-30H-190v306h666c-6.8-20.8-62.4-45.9-87.2-52.8-20.8-5.8-72.9-15.5-87.2-55.2-10.1-28 19.6-119.2-60.2-135.5C142 12 145.2-16 142-30Z"
      }), _jsx("g", {
        filter: `url(#${idE})`,
        children: _jsx("path", {
          fill: `url(#${idF})`,
          d: "m1172.8 205.5 162.6-93.9-177-306.6L832-6.5c15.4 18.9 57.1 28.2 73.3 28.2 13.5-.1 44.6-5.1 74.6 30.6 21.2 25.3 59.4 125 108 118.8 60.5-7.8 75.1 21.3 84.9 34.4Z"
        })
      })]
    }), _jsxs("defs", {
      children: [_jsxs("linearGradient", {
        id: idB,
        x1: "837.5",
        x2: "612.2",
        y1: "-54.3",
        y2: "174.9",
        gradientUnits: "userSpaceOnUse",
        children: [_jsx("stop", {
          stopColor: from
        }), _jsx("stop", {
          offset: "1",
          stopColor: to
        })]
      }), _jsxs("linearGradient", {
        id: idC,
        x1: "467.1",
        x2: "220.4",
        y1: "-172.7",
        y2: "-125.7",
        gradientUnits: "userSpaceOnUse",
        children: [_jsx("stop", {
          stopColor: from
        }), _jsx("stop", {
          offset: "1",
          stopColor: to
        })]
      }), _jsxs("linearGradient", {
        id: idD,
        x1: "384.5",
        x2: "-111.8",
        y1: "-30",
        y2: "103.9",
        gradientUnits: "userSpaceOnUse",
        children: [_jsx("stop", {
          stopColor: to
        }), _jsx("stop", {
          offset: "1",
          stopColor: from
        })]
      }), _jsxs("linearGradient", {
        id: idF,
        x1: "832",
        x2: "1231.8",
        y1: "-6.5",
        y2: "161.5",
        gradientUnits: "userSpaceOnUse",
        children: [_jsx("stop", {
          stopColor: from
        }), _jsx("stop", {
          offset: "1",
          stopColor: to
        })]
      }), _jsx("clipPath", {
        id: idA,
        children: _jsx("path", {
          fill: "#fff",
          d: "M0 0h1248v100H0z"
        })
      }), _jsxs("filter", {
        id: idE,
        width: "503.4",
        height: "404.5",
        x: "832",
        y: "-195",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse",
        children: [_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), _jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), _jsx("feColorMatrix", {
          in: "SourceAlpha",
          result: "hardAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), _jsx("feOffset", {
          dy: "4"
        }), _jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), _jsx("feComposite", {
          in2: "hardAlpha",
          k2: "-1",
          k3: "1",
          operator: "arithmetic"
        }), _jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), _jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow_348_36479"
        })]
      })]
    })]
  });
}, process.env.NODE_ENV === "production" ? {
  target: "ev50wsw0"
} : {
  target: "ev50wsw0",
  label: "Background"
})(process.env.NODE_ENV === "production" ? {
  name: "2nabv6",
  styles: "position:absolute;top:0;left:0;min-height:100%;min-width:100%"
} : {
  name: "2nabv6",
  styles: "position:absolute;top:0;left:0;min-height:100%;min-width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});